import type { Summary } from './types';

export function renderLongform(summary: Summary): HTMLElement {
  const wrapper = document.createElement('div');
  wrapper.className = 'longform-list';
  summary.responses?.forEach((response) => {
    const item = document.createElement('div');
    item.className = 'longform-item';
    item.textContent = response;
    wrapper.appendChild(item);
  });
  return wrapper;
}

const PREFIX_RE = /^\[([^\]]+)\]\s*/;

export function renderCategorizedLongform(summary: Summary): HTMLElement {
  const wrapper = document.createElement('div');
  wrapper.className = 'longform-categorized';

  const order: string[] = [];
  const categories = new Map<string, string[]>();

  (summary.responses ?? []).forEach((response) => {
    const m = response.match(PREFIX_RE);
    const cat = m ? m[1] : '';
    const text = m ? response.slice(m[0].length) : response;
    if (!categories.has(cat)) { categories.set(cat, []); order.push(cat); }
    categories.get(cat)!.push(text);
  });

  order.forEach((category) => {
    const responses = categories.get(category)!;
    const section = document.createElement('div');
    section.className = 'longform-category';

    const header = document.createElement('h4');
    header.className = 'longform-category-header';
    header.textContent = `${category || 'Other'} (${responses.length})`;
    section.appendChild(header);

    const list = document.createElement('div');
    list.className = 'longform-list';
    responses.forEach((response) => {
      const item = document.createElement('div');
      item.className = 'longform-item';
      item.textContent = response;
      list.appendChild(item);
    });
    section.appendChild(list);
    wrapper.appendChild(section);
  });

  return wrapper;
}
